import React from "react";
// Material ui core
import Chip from "@material-ui/core/Chip";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import CircularProgress from "@material-ui/core/CircularProgress";
// App components
import SearchInput from "../../components/SearchInput";
// Material ui icons
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AddBoxIcon from "@material-ui/icons/AddBox";
// Styles
import { withStyles } from "@material-ui/core/styles";
import _ from "lodash";
import { connect } from "react-redux";

const styles = theme => ({
  root: {
    width: "100%"
  },
  search: {
    marginBottom: theme.spacing(2)
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  chipRoot: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap"
  },
  chip: {
    margin: theme.spacing(1)
  },
  addSlotField: {
    margin: theme.spacing(1)
  }
});

class CustomSlotsList extends React.Component {
  state = { expanded: true, slotSearchValue: "", slots: [], newCustomSlotTypeName: "" };

  componentDidMount() {
    this.saveSlotsInState();
  }

  saveSlotsInState = () => {
    let slots = [];

    if (this.props.listCustomSlotTypesResponse && this.props.listCustomSlotTypesResponse.custom_slots) {
      slots = this.props.listCustomSlotTypesResponse.custom_slots.map((slot, index) => {
        slot["index"] = index;
        return slot;
      });
    }

    this.setState(prevState => ({
      ...prevState,
      slots: slots
    }));
  };

  handleExpandSlotsList = () => {
    this.setState(prevState => ({
      expanded: !prevState.expanded
    }));
  };

  handleSearchSlots = e => {
    const searchTerm = e.target.value;
    this.setState({ slotSearchValue: searchTerm, expanded: true });
  };

  filterSearchedCustomSlotTypesReducer = (visibleCustomSlotTypes, slot, index) => {
    const { classes, selectedSlot, handleSelectSlot, handleDeleteCustomSlotClick } = this.props;
    const { slotSearchValue } = this.state;

    const slotTypeChip = (
      <Chip
        key={index}
        variant={index === selectedSlot ? "default" : "outlined"}
        clickable
        label={slot.slotName}
        onClick={() => {
          handleSelectSlot(index);
        }}
        onDelete={() => handleDeleteCustomSlotClick(slot.ID)}
        className={classes.chip}
        color="primary"
      />
    );

    if (slotSearchValue && slotSearchValue.length) {
      const lowercaseSlotSearchValue = slotSearchValue.toLowerCase();

      if (_.includes(slot.slotName.toLowerCase(), lowercaseSlotSearchValue)) {
        visibleCustomSlotTypes.push(slotTypeChip);
      }
    } else {
      visibleCustomSlotTypes.push(slotTypeChip);
    }

    return visibleCustomSlotTypes;
  };

  renderListOfSlots = () => {
    if (this.props.listCustomSlotTypesResponse && this.props.listCustomSlotTypesResponse.custom_slots) {
      return this.props.listCustomSlotTypesResponse.custom_slots.reduce(this.filterSearchedCustomSlotTypesReducer, []);
    }

    return <CircularProgress />;
  };

  handleNewCustomSlotTypeNameChange = event => {
    const newSlotTypeName = event.currentTarget.value.trim();
    this.setState({
      newCustomSlotTypeName: newSlotTypeName
    });
  };

  render() {
    const { classes, createNewCustomSlot } = this.props;
    const { expanded, slotSearchValue, newCustomSlotTypeName } = this.state;

    return (
      <React.Fragment>
        <SearchInput
          value={slotSearchValue}
          className={classes.search}
          onChange={this.handleSearchSlots}
          placeholder="Search Custom Slots"
        />
        <ExpansionPanel expanded={expanded} onChange={this.handleExpandSlotsList}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>Custom Slots</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.chipRoot}>
            <TextField
              className={classes.addSlotField}
              placeholder="Add Custom Slot"
              ref="newCustomSlotTypeField"
              onChange={this.handleNewCustomSlotTypeNameChange}
            />
            <IconButton
              onClick={() => {
                createNewCustomSlot(newCustomSlotTypeName);
              }}
            >
              <AddBoxIcon />
            </IconButton>
          </ExpansionPanelDetails>
          <ExpansionPanelDetails className={classes.chipRoot}>{this.renderListOfSlots()}</ExpansionPanelDetails>
        </ExpansionPanel>
      </React.Fragment>
    );
  }
}

const styledCustomSlotsList = withStyles(styles)(CustomSlotsList);

const mapStateToProps = state => {
  return {
    listCustomSlotTypesResponse: state.customSlots.listCustomSlotTypesResponse
  };
};

export default connect(mapStateToProps)(styledCustomSlotsList);
